<template>
  <div class="button-bar">
    <component
      class="bottom-bar-button"
      :class="{
        blue: (item == 'vipDetail' || item == 'login') && mode == 'invite-fans'
      }"
      v-for="(item, index) in modeToRule[mode]()"
      :key="index"
      :is="item"
      @click.native="$emit('bottomBarHandler', item)"
    >
      <template v-slot:[item]>
        <slot :name="item">
          <template v-if="item == 'navigate'">{{
            navigateDetail.name
          }}</template>
        </slot>
      </template>
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import {
  BuyButton,
  LoginButton,
  ShareButton,
  VIPDetailButton,
  DownloadButton,
  NavigateButton
} from '@/components/goods/button'
import {
  SalesVolumeButton,
  LessonBuyButton,
  LessonShareButton
} from '@/components/course/button'
const BUTTON_TYPE = {
  login: 'login',
  share: 'share',
  buy: 'buy',
  vip: 'vipDetail',
  download: 'downloadApp',
  navigate: 'navigate',
  salesVolume: 'salesVolume',
  lessonBuy: 'lessonBuy',
  lessonShare: 'lessonShare'
}
export default {
  props: {
    mode: {
      type: String
    },
    rule: {
      type: Array
    },
    buyState: {
      type: Boolean,
      default: false
    },
    isFree: {
      type: Boolean,
      default: false
    },
    disableDate: {
      type: String | Object
    }
  },
  data () {
    return {
      navigateDetail: {
        name: '',
        url: ''
      }
    }
  },
  methods: {
    pkgRule () {
      let buttonArr = []
      if (this.disableDate == 'disable') {
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.isVisitor || isEmpty(this.userInfo)) {
        // buttonArr.push(BUTTON_TYPE.login)
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.buyState) {
        this.navigateDetail = { name: '前往学习儿童VIP课程', url: '' }
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.navigate)
      } else {
        this.navigateDetail = { name: '体验VIP课程', url: '' }
        if (!this.isNative) {
          buttonArr.push(BUTTON_TYPE.navigate)
        }
        buttonArr.push(BUTTON_TYPE.buy)
      }
      return buttonArr
    },
    parentPkgRule () {
      let buttonArr = []
       if (this.disableDate == 'disable') {
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.isVisitor || isEmpty(this.userInfo)) {
        // buttonArr.push(BUTTON_TYPE.login);
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.buyState) {
        this.navigateDetail = { name: '前往学习课程', url: '' }
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.navigate)
      } else {
        buttonArr.push(BUTTON_TYPE.buy)
      }
      return buttonArr
    },
    aiPkgRule () {
      let buttonArr = []
       if (this.disableDate == 'disable') {
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.isVisitor || isEmpty(this.userInfo)) {
        // buttonArr.push(BUTTON_TYPE.login)
        buttonArr.push(BUTTON_TYPE.buy)
      } else if (this.buyState) {
        this.navigateDetail = { name: '前往学习AI课件', url: '' }
        buttonArr.push(BUTTON_TYPE.share)
        buttonArr.push(BUTTON_TYPE.navigate)
      } else {
        buttonArr.push(BUTTON_TYPE.buy)
      }
      return buttonArr
    },
    pkgListRule () {
      return [BUTTON_TYPE.vip, BUTTON_TYPE.buy]
    },
    inviteFansRule () {
      let buttonArr = []
      if (this.isVisitor || isEmpty(this.userInfo)) {
        buttonArr.push(BUTTON_TYPE.login)
      } else {
        buttonArr.push(BUTTON_TYPE.download)
      }
      buttonArr.push(BUTTON_TYPE.vip)
      return buttonArr
    },
    lessonOfflineDetailRule () {
      let buttonArr = []
      if (this.isVisitor || isEmpty(this.userInfo)) {
        buttonArr.push(BUTTON_TYPE.salesVolume)
        buttonArr.push(BUTTON_TYPE.lessonBuy)
      } else if (this.isFree) {
        buttonArr.push(BUTTON_TYPE.salesVolume)
        this.buyState
          ? buttonArr.push(BUTTON_TYPE.buy)
          : buttonArr.push(BUTTON_TYPE.lessonBuy)
      } else {
        this.isPlusMember
          ? buttonArr.push(BUTTON_TYPE.lessonShare)
          : buttonArr.push(BUTTON_TYPE.salesVolume)
        this.buyState
          ? buttonArr.push(BUTTON_TYPE.buy)
          : buttonArr.push(BUTTON_TYPE.lessonBuy)
      }
      return buttonArr
    }
  },
  computed: {
    ...mapGetters({
      isNative: 'externalInterface/isNative',
      isVisitor: 'auth/isVisitor',
      userInfo: 'auth/userInfo',
      isPlusMember: 'auth/isPlusMember'
    }),
    normalizedRule () {
      let buttonArr = []
      return buttonArr
    },
    modeToRule () {
      return {
        'parent-pkg': this.parentPkgRule,
        'ai-pkg': this.aiPkgRule,
        'pkg-detail': this.pkgRule,
        'pkg-list': this.pkgListRule,
        'invite-fans': this.inviteFansRule,
        'lesson-offline-detail': this.lessonOfflineDetailRule
      }
    }
  },
  components: {
    buy: BuyButton,
    login: LoginButton,
    share: ShareButton,
    vipDetail: VIPDetailButton,
    downloadApp: DownloadButton,
    navigate: NavigateButton,
    salesVolume: SalesVolumeButton,
    lessonBuy: LessonBuyButton,
    lessonShare: LessonShareButton
  }
}
</script>

<style scoped>
.button-bar {
  width: 100vw;
  position: fixed;
  z-index: 3;
  bottom: -1px;
  display: flex;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
}
.button-bar >>> .bottom-bar-button {
  display: block;
  flex: 1;
  /* text-align: center; */
  font-size: 14px;
  /* line-height: 52px; */
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
